import React, { useContext, memo, useEffect, useMemo } from 'react';
import NavbarListItem from 'modules/common/Navbar/NavbarListItems/NavbarListItem';
import NavbarListItemProfile from 'modules/common/Navbar/NavbarListItems/NavbarListItemProfile';
import { Translator } from 'Translator';
import { generatePathnameWithLangCode } from 'utils/RouteHelper';
import { UserEnvironmentContext } from '~/context/UserEnvironmentContext';
import { selectUnreadMessageCount } from '~/context/UserEnvironmentContext/selectors/selectUnreadMessageCount';
import { useNotificationsStore } from '~/context/NotificationsContext';
import UpdatesBellIcon from "components/icons/UpdatesBellIcon";
import classnames from 'classnames';
import { BUY_A_GIFT_VOUCHER_LINK } from '~/constants';

const CSS = require('./LoggedInLinks.less');

interface LoggedInLinksProps {
  transparent: boolean;
  isHost?: boolean;
  isMobile: boolean;
}

function LoggedInLinks({ transparent, isHost, isMobile }: LoggedInLinksProps) {
  const { chatContacts, contacts, actions } = useContext(UserEnvironmentContext);
  const unreadMessageCount = useMemo(() => selectUnreadMessageCount(chatContacts, contacts), [chatContacts, contacts]);
  const updatesStore = useNotificationsStore();

  useEffect(() => {
    if (!chatContacts.meta && !chatContacts.loading) {
      actions.chatContacts.fetchContacts({ page: 1, pageSize: 10 });
    }
  }, [actions.chatContacts, chatContacts]);


  return (
    <ul className={CSS.Links}>
      {!isMobile && !isHost &&
        <NavbarListItem
          to={BUY_A_GIFT_VOUCHER_LINK}
          transparent={transparent}
          externalLink={true}
        >
          Buy a gift voucher
        </NavbarListItem>
      }
      {isHost && !isMobile &&
        <NavbarListItem
          to={generatePathnameWithLangCode('/host-agenda/', Translator.getLanguageCode())}
          transparent={transparent}
        >
          {Translator.translate('Navbar.Buttons.agenda', {}, true, 'Agenda')}
        </NavbarListItem>
      }
      <NavbarListItem
        to={generatePathnameWithLangCode('/schedule/', Translator.getLanguageCode())}
        transparent={transparent}
      >
        {Translator.translate('Navbar.Buttons.bookings', {}, true, 'Bookings')}
      </NavbarListItem>
      <NavbarListItem
        to={generatePathnameWithLangCode('/messages/', Translator.getLanguageCode())}
        transparent={transparent}
        notificationBubble={unreadMessageCount > 0}
      >
        {Translator.translate('Navbar.Buttons.chat', {}, true, 'Chat')}
      </NavbarListItem>
      {
        isHost &&
        <NavbarListItem
          to={generatePathnameWithLangCode('/host/updates-center/', Translator.getLanguageCode())}
          transparent={transparent}
          notificationBubble={updatesStore?.unreadCount > 0}
        >
          <div>
            <UpdatesBellIcon className={classnames(CSS.BellIcon, { [CSS.BellIconTransparent]: transparent })} height={18}/>
          </div>
        </NavbarListItem>
      }
      {!isHost &&
        <NavbarListItem
          to={generatePathnameWithLangCode('/favorites/', Translator.getLanguageCode())}
          transparent={transparent}
        >
          {Translator.translate('Navbar.Buttons.favorites', {}, true, 'Favorites')}
        </NavbarListItem>
      }
      <li className={CSS.ProfileItem}>
        <NavbarListItemProfile transparent={transparent} />
      </li>
    </ul>
  );
}

export default memo(LoggedInLinks);
